// extracted by mini-css-extract-plugin
export var avatar = "_mq-3";
export var avatarContainer = "_mq-2";
export var avatarSpacer = "_mq-5";
export var avatarSpacerContainer = "_mq-4";
export var avatarStackContainer = "_mq-1";
export var bubble = "_mq-0";
export var remainderBubble = "_mq-6";